(() => {
  if (customElements.get('aestara-product-pill')) return;
  const treatments = { Dark: 'bestseller', Gold: 'finish', Light: 'matching' };
  const normalize = value => String(value || '').trim().toLocaleLowerCase();
  const readList = value => {
    try { const parsed = JSON.parse(value || '[]'); return Array.isArray(parsed) ? parsed : []; }
    catch { return []; }
  };
  class ProductPill extends HTMLElement {
    connectedCallback() {
      this.context = this.closest('[data-card-swatches]') || this.closest('product-info') || this.parentElement;
      this.refresh = this.refresh.bind(this);
      this.queue = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.refresh(); });
      };
      this.context.addEventListener('click', this.queue);
      this.context.addEventListener('change', this.queue);
      this.observer = new MutationObserver(this.queue);
      this.observer.observe(this.context, {
        subtree: true, childList: true, attributes: true,
        attributeFilter: ['data-variant-id', 'aria-pressed', 'src', 'alt', 'data-pills'],
      });
      this.parentElement.classList.add('aestara-pill-host');
      this.refresh();
    }
    disconnectedCallback() {
      this.context?.removeEventListener('click', this.queue);
      this.context?.removeEventListener('change', this.queue);
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }
    refresh() {
      const card = this.closest('[data-card-swatches]');
      const gallery = this.closest('media-gallery') || this.context.querySelector('media-gallery');
      const activeSwatch = card?.querySelector('[data-card-swatch][aria-pressed="true"], [data-card-swatch].is-active');
      const variants = readList(this.dataset.variants);
      const variantId = gallery?.dataset.variantId || new URL(location.href).searchParams.get('variant');
      const variant = variants.find(v => String(v.id) === String(variantId));
      const pickerFinish = this.context.querySelector('variant-selects [data-option-role="finish"] input:checked')?.value
        || this.context.querySelector('variant-selects [data-selected-value]')?.textContent.trim();
      const finish = normalize(activeSwatch?.getAttribute('title') || pickerFinish || variant?.finish || this.dataset.finish);
      const seen = new Set();
      const labels = readList(this.dataset.pills).filter(pill => {
        if (!pill || typeof pill.text !== 'string' || !pill.text.trim()) return false;
        const key = normalize(pill.text);
        if (seen.has(key)) return false;
        if (Array.isArray(pill.finishes) && pill.finishes.length && !pill.finishes.some(value => normalize(value) === finish)) return false;
        seen.add(key);
        return true;
      }).slice(0, 3).map(pill => ({
        text: pill.text.trim(),
        kind: treatments[pill.style] || treatments.Light,
        description: typeof pill.description === 'string' ? pill.description.trim() : '',
      }));
      const signature = JSON.stringify(labels);
      if (this.signature !== signature) {
        this.signature = signature;
        this.replaceChildren(...labels.map(label => {
          const chip = document.createElement('span');
          chip.className = 'aestara-pill';
          chip.dataset.kind = label.kind;
          chip.textContent = label.text;
          if (label.description) chip.setAttribute('aria-label', `${label.text}: ${label.description}`);
          return chip;
        }));
      }
      this.hidden = !labels.length;
    }
  }
  customElements.define('aestara-product-pill', ProductPill);
})();
